import { Injectable } from '@angular/core';

@Injectable()
export class CMoveRequest {

    //PROPERTIES

    request_id: any;
    owner: any;
    state: any;
    sops_remaining: any;
    sops_complete: any;
    sops_failed: any;
    sops_canceled: any;
    sops_warning: any;
    study_path: any;
    calling_ae_title: any;
    peer_ae_title: any;
    peer_host: any;
    peer_port: any;
    assign_new_uids: any;
    delete_private_tags: any;
    save_files: any;
    network_timeout: any;
    acse_timeout: any;
    dimse_timeout: any;
    max_pdu: any;
    category: any;
    subcategory: any;
    wado_patient_record_id: any;
    wado_study_record_id: any;
    dt_inserted: any;
    dt_last_modified: any;


    //CONSTRUCTOR
    constructor();
    constructor(request: any);
    constructor(request?: any) {
        this.request_id = (request) ? request.request_id : null;
        this.owner = (request) ? request.owner : null;
        this.state = (request) ? request.state : null;
        this.sops_remaining = (request) ? request.sops_remaining : null;
        this.sops_complete = (request) ? request.sops_complete : null;
        this.sops_failed = (request) ? request.sops_failed : null;
        this.sops_canceled = (request) ? request.sops_canceled : null;
        this.sops_warning = (request) ? request.sops_warning : null;
        this.study_path = (request) ? request.study_path : null;
        this.calling_ae_title = (request) ? request.calling_ae_title : null;
        this.peer_ae_title = (request) ? request.peer_ae_title : null;
        this.peer_host = (request) ? request.peer_host : null;
        this.peer_port = (request) ? request.peer_port : null;
        this.assign_new_uids = (request) ? request.assign_new_uids : null;
        this.delete_private_tags = (request) ? request.delete_private_tags : null;
        this.save_files = (request) ? request.save_files : null;
        this.network_timeout = (request) ? request.network_timeout : null;
        this.acse_timeout = (request) ? request.acse_timeout : null;
        this.dimse_timeout = (request) ? request.dimse_timeout : null;
        this.max_pdu = (request) ? request.max_pdu : null;
        this.category = (request) ? request.category : null;
        this.subcategory = (request) ? request.subcategory : null;
        this.wado_patient_record_id = (request) ? request.wado_patient_record_id : null;
        this.wado_study_record_id = (request) ? request.wado_study_record_id : null;
        this.dt_inserted = (request) ? request.dt_inserted : null;
        this.dt_last_modified = (request) ? request.dt_last_modified : null;
    } //end constructor

} //end class